import React from "react";
import AdminDashboard from "./AdminDashboard";

export default function Dashboard() {

  const role = localStorage.getItem("userRole");

  if (role === "admin") {
    return <AdminDashboard />;
  }


  return (

    <div style={{ padding: "40px" }}>

      <h2>No role found</h2>

      <button
        onClick={() =>
          window.location.href =
            "/admin-login"
        }
      >
        Go to Login
      </button>

    </div>

  );

}